<template>
	<div class="business">
		<div class="business-body">
			<div class="business-main">
				<div class="fx-title">
					<p>基础信息</p>
				</div>
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" :inline-message='true' label-position='right' label-width="100px" class="box">
					<div class="business-top-row">
						<div class="business-basic-fields">
							<el-form-item label="客户名称:" prop='name'>
								<el-input class='input-box' :disabled="isDisabled" v-model="ruleForm.name" :maxlength='
								100' size='mini' placeholder="请输入客户名称" @blur="nameChange"></el-input>
							</el-form-item>
							<el-form-item label="客户账号:" :prop="ruleForm.disabledflag === 0 ? 'username' : ''">
								<el-input class='input-box' :disabled="userNameDisabled" v-model="ruleForm.username" :minlength='11' :maxlength='
								11' size='mini' placeholder="请输入11位手机号" autocomplete="new-password"></el-input>
							</el-form-item>
							<el-form-item label="客户密码:" prop='password'>
								<el-input class='input-box inputPsd' :disabled="isDisabled" v-model="ruleForm.password" :minlength='6' :maxlength='
								20' size='mini' placeholder="请填写6-20位字母和数字组合密码"></el-input>
							</el-form-item>
							<el-form-item label="客户类别:">
								<el-select :disabled="isDisabled" v-model="ruleForm.customercategoryid" class="input-box" size='small'>
									<el-option v-for="(item,index) in customercategoryList" :key='index' :value="item.ccid" :label="item.ccname"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="客户编号:">
								<el-input
								:disabled="isDisabled"
								class='input-box'
								@input="codeChange"
								type='text'
								v-model="ruleForm.code"
								size='mini'
								:maxlength='18'
								@mousewheel.native.prevent
								placeholder="请输入客户编号"></el-input>
							</el-form-item>
							<el-form-item label="客户注册码:">
								<el-input  class='input-box' v-model="ruleForm.syscode" :maxlength='
								20' size='mini' placeholder="客户注册码" disabled></el-input>
							</el-form-item>
							<el-form-item label="启用状态:">
								<div style="text-align:left">
									<el-radio-group size='mini' v-model="ruleForm.disabledflag">
										<el-radio :label="0" :disabled="isDisabled">启用</el-radio>
										<el-radio :label="1" :disabled="isDisabled">停用</el-radio>
									</el-radio-group>
								</div>
							</el-form-item>
						</div>
						<div class="business-picture-area" v-if="showCustomerPhotos">
							<CustomerPhotoUpload
								title="营业执照"
								:imgSrc.sync="ruleForm.businessLicenseUrl"
								:canEdit="!isDisabled"
							></CustomerPhotoUpload>
							<CustomerPhotoUpload
								title="门店照"
								:imgSrc.sync="ruleForm.storePhotoUrl"
								:canEdit="!isDisabled"
							></CustomerPhotoUpload>
						</div>
					</div>
					<el-form-item label="可购买商品显示范围:" label-width="150px" class="radio-row-horizontal">
						<div style="text-align:left">
							<el-radio-group size='mini' v-model="ruleForm.productQueryType">
								<el-radio :label="0">仅展示绑定的私密商品与所有公开商品</el-radio>
								<el-radio :label="1">仅展示绑定的公开商品与所有公开商品</el-radio>
							</el-radio-group>
						</div>
					</el-form-item>
					<el-form-item label="商品下单渠道:" label-width="150px" class="radio-row-horizontal">
						<div style="text-align:left">
							<el-radio-group size='mini' v-model="ruleForm.orderChannelType">
								<el-radio :label="0">不限制下单渠道</el-radio>
								<el-radio :label="1">仅允许常购清单下单</el-radio>
							</el-radio-group>
						</div>
					</el-form-item>
					<el-form-item label="线上开票:">
						<div style="text-align:left">
							<el-radio-group size='mini' v-model="ruleForm.invoiceFlag">
								<el-radio :label="1" :disabled="isDisabled">允许</el-radio>
								<el-radio :label="0" :disabled="isDisabled">不允许</el-radio>
							</el-radio-group>
						</div>
					</el-form-item>
					<el-form-item label="是否允许小程序修改客户名称:" label-width="200px">
						<div style="text-align:left">
							<el-radio-group size='mini' v-model="ruleForm.editnameflag">
								<el-radio :label="0">不允许</el-radio>
								<el-radio :label="1">允许</el-radio>
							</el-radio-group>
						</div>
					</el-form-item>
					<div style="display:flex">
						<el-form-item label="最小订货数量限制:" label-width="150px">
							<el-input
								:disabled="isDisabled"
								class='input-box'
								@input="minBuyAmountInput"
								@blur="minBuyAmountBlur"
								type='text'
								v-model="ruleForm.minBuyAmount"
								size='mini'
							></el-input>
							<el-checkbox v-model="ruleForm.replaceMinAmountFlag" :true-label="1" :false-label="0" style="line-height: 40px;margin-left: 10px">应用至代客下单</el-checkbox>
						</el-form-item>
					</div>
					<div style="display:flex">
						<el-form-item label="最小订货金额限制:" label-width="150px">
							<el-input
							:disabled="isDisabled"
							class='input-box'
							@blur="minBuyMoneyBlur"
							type='text'
							v-model="ruleForm.minBuyMoney"
							size='mini'
							@mousewheel.native.prevent></el-input>
							元
							<el-checkbox v-model="ruleForm.replaceMinMoneyFlag" :true-label="1" :false-label="0" style="line-height: 40px;margin-left: 10px">应用至代客下单</el-checkbox>
						</el-form-item>
					</div>
					<div style="display:flex">
						<el-form-item label="最大订货金额限制:" label-width="150px">
							<el-input
							:disabled="isDisabled"
							class='input-box'
							@blur="maxBuyMoneyBlur"
							type='text'
							v-model="ruleForm.maxBuyMoney"
							size='mini'
							@mousewheel.native.prevent></el-input>
							元
							<el-checkbox v-model="ruleForm.replaceMaxMoneyFlag" :true-label="1" :false-label="0" style="line-height: 40px;margin-left: 10px">应用至代客下单</el-checkbox>
						</el-form-item>
					</div>
					<div style="display: flex;padding-left: 20px;color: red;">
						提示:最小订货数量限制默认为‘0’,最小订货金额限制默认为‘0’,最大订货金额默认为空，为空则不限制最大订货金额，最大订货金额为‘0’则代表只能0金额下单
					</div>
					<div style="border-top:1px solid #dce2fd;margin:10px 0"></div>
					<div class="fx-title">
						<p>其他信息</p>
					</div>
					<el-form-item>
						<template slot="label">
							<i class="el-icon--right" :class="otherInfoCollapse ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" style="cursor: pointer; margin-right: 4px; vertical-align: middle;" @click="handleOtherInfoCollapse"/>
							所属员工:
						</template>
						<span v-show="otherInfoCollapse">{{users}}</span>
					</el-form-item>
					<el-form-item label="联系人:">
						<el-input  class='input-box' @input="linkmanChange" v-model="ruleForm.linkman" :maxlength='
						50' size='mini' placeholder="联系人"></el-input>
					</el-form-item>
					<el-form-item label="联系电话:">
						<el-input  class='input-box' type="text" @input="linktelChange" v-model="ruleForm.linktel" :maxlength='
						11' size='mini' placeholder="联系电话"></el-input>
					</el-form-item>
					<el-form-item label="会员等级:">
						<el-select v-model="ruleForm.customerlevelid" filterable clearable class="input-box" size='small'>
							<el-option v-for="(item,index) in fixLevelList" :key='index'  :value="item.customerlevelid" :label="item.level === 0 ? item.customerlevelname : item.levelName + (item.customerlevelname === '' ? '' : '-') + item.customerlevelname"></el-option>
						</el-select>
						<i class="el-icon-circle-plus-outline add-icon" @click="addLevel"></i>
					</el-form-item>
					<el-form-item label="客户标签:">
						<el-select v-model="ruleForm.customertagid" filterable clearable class="input-box" size='small'>
							<el-option v-for="(item,index) in fixTagList" :key='index'  :value="item.customertagid" :label="item.customertagname"></el-option>
						</el-select>
						<i class="el-icon-circle-plus-outline add-icon" @click="addTag"></i>
					</el-form-item>
					<el-form-item label="区域:">
						<el-select v-model="ruleForm.area" size='small' class='input-box' @change='areaChange' clearable>
							<!-- <el-option value="0" label="全国"></el-option> -->
							<el-option
								v-for="item in areaList"
								:key="item.code"
								:label="item.name"
								:value="item.code">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="位置:" ref="postion">
						<el-select v-model="ruleForm.province" size='small' class='input-box' style="margin-right:10px" @change='provinceChange()' placeholder="请选择省份">
							<el-option
								v-for="item in provinceList"
								:key="item.id"
								:label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
						<el-select v-model="ruleForm.city"  size='small' class='input-box' style="margin-right:10px" @change='cityChange()' placeholder="请选择城市">
							<el-option
								v-for="item in cityList"
								:key="item.id"
								:label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
						<el-select v-model="ruleForm.district" size='small' class='input-box' placeholder="请选择地区">
							<el-option
								v-for="(item,index) in districtList"
								:key="index"
								:label="item.name"
								:value="item.code">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="邮箱:">
						<el-input  class='input-box' v-model="ruleForm.email" size='mini' :maxlength='18' placeholder="邮箱"></el-input>
					</el-form-item>
					<el-form-item label="所属线路:">
						<el-select v-model="ruleForm.lineid" filterable class="input-box" size='small'>
							<el-option v-for="(item,index) in lineList" :key='index'  :value="item.lineid" :label="item.codeandname"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="创建人:">
						<span>{{creator}}</span>
					</el-form-item>
					<el-form-item label="创建时间:">
						<span>{{createdate}}</span>
					</el-form-item>
					<el-form-item label="备注:">
						<el-input  class='input-box' v-model="ruleForm.memo" size='mini' placeholder="备注"></el-input>
					</el-form-item>
					<el-form-item label="附录1:">
						<el-input  class='input-box' type="textarea" v-model="ruleForm.appendixOne" size='mini' maxlength="100" placeholder="附录1"></el-input>
					</el-form-item>
					<el-form-item label="附录2:">
						<el-input  class='input-box' type="textarea" v-model="ruleForm.appendixTwo" size='mini' maxlength="100" placeholder="附录2"></el-input>
					</el-form-item>
					<el-form-item label="关联店铺:">
						<span>{{shopname}}</span>
					</el-form-item>
					<div v-if="shopList.length > 1">
						<div class="fx-title">
							<p>适用门店</p>
						</div>
						<el-form-item label="适用门店：" prop=" " size='mini'>
							<el-radio v-model="shopattendway" :label="true">全部门店</el-radio>
							<el-radio v-model="shopattendway" :label="false">自定义门店</el-radio>
							<span v-if="shopattendway === false" @click="bindShopClick" style="margin-left:10px;color:var(--fx-primary-color);cursor: pointer;font-size: 12px;">
								<i style="font-size: 14px;" class="el-icon-circle-plus"></i>
								选择门店
							</span>
						</el-form-item>
						<el-form-item v-if="shopattendway === false" label="已选：" size='mini'>
							<span>{{shopText}}</span>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div class="business-right">
				<div class="fx-title" style="display: flex;align-items: center;">
					<p>收货地址</p>
					<el-button type="primary" plain size="mini" style="margin-left: 30px;" v-if="!addFlag && AuthorityList['03_0001_0015_00']" @click="addAddress('add')">新增</el-button>
				</div>
				<div class="right-address" v-for="item in addrList" :key="item.id">
					<div style="display:flex;flex-flow:row;align-items: center;">
						<p>{{item.defaultflag ? '默认地址' : '其他地址'}}</p>
						<i class="el-icon-edit-outline" v-if="AuthorityList['03_0001_0016_00']" @click="addAddress('edit', item)"></i>
						<i class="el-icon-delete" v-if="AuthorityList['03_0001_0017_00']" @click="deleteAddress(item)"></i>
					</div>
					<div class="address-item"><span>收货人姓名：</span>{{item.name}}</div>
					<div class="address-item"><span>手机号码：</span>{{item.tel}}</div>
					<div class="address-item"><span>省市区：</span>{{item.provincename}}{{item.cityname}}{{item.districtname}}</div>
					<div class="address-item"><span>街道地址：</span>{{item.addr.detail}}</div>
					<div class="address-item"><span>收货地址：</span>{{item.addr.local}}</div>
					<!-- <div class="address-item"><span>收货地址：</span>{{item.addr}}</div> -->
				</div>
			</div>
        </div>
        <div class="business-foot" v-if="!isDisabled">
            <el-button class="fx-big-btn" plain type="primary" size='small' @click="resetForm('ruleForm')">重置</el-button>
            <el-button class="fx-big-btn" plain type="primary" size='small' @click="submitForm('ruleForm')">确认</el-button>
        </div>
		<el-dialog title="会员等级管理" class="dialog-title1" :visible.sync="levelModal" width='600px' @open='levelOpen' :close-on-click-modal="false">
			<div style="text-align: left;margin: 10px 0;">
				<el-button size='small' type="primary" style="" plain class='fx-big-btn' @click="addBarcode">新增</el-button>
			</div>
			<div class="bar-wrap">
				<div class="bar-box" v-for="(item, index) in newLevelData" :key="index">
					<div class="bar-content">
						<div style="width:100px;margin-right:20px">{{item.level !== 0 ? item.levelName : ''}}</div>
						<el-input style="width:250px;" type="text" placeholder="最多输入8个字" @input="levelChange(index)" size='mini' maxlength="8" v-model='item.customerlevelname'></el-input>
					</div>
					<div class="bar-delete" @click="deleteNew(index)">删除</div>
				</div>
				<!-- <div v-for="(item, index) in levelList" :key="item.customerlevelid">
					<div class="bar-box">
						<div class="bar-content">
							<div>{{item.customerlevelname}}</div>
						</div>
						<div class="bar-delete" @click="deleteOld(item.customerlevelid, index)">删除</div>
					</div>
				</div> -->
			</div>
			<div class="valet-foot">
				<el-button class="btn fx-big-btn" plain type="primary" size='small' @click="closeLevel">取消</el-button>
				<el-button class="btn fx-big-btn" plain type="primary" size='small' @click="saveLevel">保存</el-button>
			</div>
		</el-dialog>
		<el-dialog title="客户标签管理" class="dialog-title1" :visible.sync="tagModal" width='600px' @open='tagOpen' :close-on-click-modal="false">
			<div style="text-align: left;margin: 10px 0;">
				<el-button size='small' type="primary" style="" plain class='fx-big-btn' @click="addTagName">新增</el-button>
			</div>
			<div class="bar-wrap">
				<div class="bar-box" v-for="(item, index) in newTagData" :key="item.id">
					<div class="bar-content">
						<el-input type="text" placeholder="最多输入18个字" @input="tagChange(index)" size='mini' maxlength="18" v-model='item.customertagname'></el-input>
					</div>
					<div class="bar-delete" @click="deleteTagNew(index)">删除</div>
				</div>
				<div v-for="(item, index) in tagList" :key="item.customertagid">
					<div class="bar-box">
						<div class="bar-content">
							<div>{{item.customertagname}}</div>
						</div>
						<div class="bar-delete" @click="deleteTagOld(item.customertagid, index)">删除</div>
					</div>
				</div>
			</div>
			<div class="valet-foot">
				<el-button class="btn fx-big-btn" plain type="primary" size='small' @click="closeTag">取消</el-button>
				<el-button class="btn fx-big-btn" plain type="primary" size='small' @click="saveTag">保存</el-button>
			</div>
		</el-dialog>
		<el-dialog class="dialog-title" title="查看二维码" top='60px' :before-close='closeModal' :visible.sync="showModal" width='350px' :close-on-click-modal="false">
			<div>
				<p style="text-align: center">
					{{staffName}}-{{ruleForm.invitationcode}}
				</p>
				<div style="width:200px;height:200px;margin-left:55px;margin-top:10px">
					<w-image :src='imgurl' style="width:200px;height:200px"></w-image>
				</div>
				<div style="text-align: center;margin-top:10px">
					<el-button style="width:200px" size='mini' type='primary' @click="downLoadImg">下载</el-button>
				</div>

			</div>
    </el-dialog>
		<el-dialog
			top='100px'
			title="选择适用门店"
			class="dialog-title"
			:visible.sync="shopDialog"
			width="780px"
			:close-on-click-modal="false">
			<div>
				<bindShop v-if="shopDialog" :customerDialog.sync='shopDialog' :chooseData1='chooseShop' @reloadCus='reloadShop'></bindShop>
			</div>
		</el-dialog>
		<el-dialog class="dialog-title" :title="addressTitle" top='60px' width="610px" :before-close="closeAddressModal" :visible.sync="showAddressModal" :close-on-click-modal="false">
			<div class="address">
				<el-form :model="addressRuleForm" :rules="addressRules" ref="addressRuleForm" label-width="100px">
					<el-form-item label="收货人姓名:" prop='name'>
						<el-input class='input-box' v-model="addressRuleForm.name" :maxlength='
						50' size='mini' placeholder="请填写收货人姓名"></el-input>
					</el-form-item>
					<el-form-item label="手机号码:" prop='tel'>
						<el-input class='input-box' v-model="addressRuleForm.tel" :minlength='11' :maxlength='
						11' size='mini' placeholder="请填写手机号码" autocomplete="new-password"></el-input>
					</el-form-item>
					<el-form-item label="所在地区:" required>
						<el-form-item prop="province">
							<el-select v-model="addressRuleForm.province" size='mini' class='input-box' style="width:150px;margin-right:10px" @change='provinceChange2($event)' placeholder="请选择省份">
								<el-option
									v-for="(item, index) in provinceList2"
									:key="index"
									:label="item.name"
									:value="addressDialogType === 'add' ? JSON.stringify(item) : item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item prop="city">
							<el-select v-model="addressRuleForm.city" size='mini' class='input-box' style="width:150px;margin-right:10px" @change='cityChange2($event)' placeholder="请选择城市">
								<el-option
									v-for="(item, index) in cityList2"
									:key="index"
									:label="item.name"
									:value="addressDialogType === 'add' ? JSON.stringify(item) : item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item prop="district">
							<el-select v-model="addressRuleForm.district" prop="district" size='mini' class='input-box' style="width:150px;" @change='districtChange2($event)' placeholder="请选择地区">
								<el-option
									v-for="(item,index) in districtList2"
									:key="index"
									:label="item.name"
									:value="addressDialogType === 'add' ? JSON.stringify(item) : item.code">
								</el-option>
							</el-select>
						</el-form-item>
					</el-form-item>
					<el-form-item label="街道地址:" prop='addr.detail' class="input540">
						<el-input class='long-input' @input="addressInput" size='mini' v-model="addressRuleForm.addr.detail" :maxlength='100' placeholder="请输入街道地址" ></el-input>
					</el-form-item>
					<el-form-item label="详细地址:" prop="addr.local" class="input540" style="height:102px">
						<el-input type="textarea" size='mini' v-model="addressRuleForm.addr.local" :rows='5' :maxlength='50' placeholder='请输入详细地址信息，如道路、门牌号、小区、楼栋号、单元等信息' resize="none" style="height:100px"></el-input>
					</el-form-item>
					<el-form-item label="设为默认地址:" prop="defaultflag" style="display:flex;align-items:center;">
						<el-switch
							v-model="addressRuleForm.defaultflag"
							active-color="#13ce66"
							inactive-color="#dcdfe6"
							style="margin-left:0;">
						</el-switch>
					</el-form-item>
					<el-form-item>
						<div style="width: 100%;text-align: right;">
							<el-button size="mini" @click="closeAddressModal('addressRuleForm')">取消</el-button>
							<el-button size="mini" type="primary" @click="submitAddressForm('addressRuleForm')">确定</el-button>
						</div>
					</el-form-item>
				</el-form>
			</div>
    </el-dialog>
	</div>
</template>

<script>
import { cityData } from '@/js/location/city.js'
import { provinceData } from '@/js/location/province.js'
import { geography } from '@/js/location/geography.js'
import { areaData } from '@/js/location/areaData.js'
import bindShop from '@/components/bindShop/bindShop.vue'
import CustomerPhotoUpload from './CustomerPhotoUpload.vue'
let _AMap = null
export default {
	name: 'business',
	components: {
		bindShop,
		CustomerPhotoUpload
	},
	data () {
		var isNull = (rule, value, callback) => {
			var reg = /^[\s\S]*.*[^\s][\s\S]*$/
			if (!(reg.test(value))) {
				return callback(new Error(''))
			} else {
				callback()
			}
		}
		return {
			otherInfoCollapse: false,
			shopname: '',
			users: '',
			imgurl: '',
			showCustomerPhotos: false,
			staffName: '',
			showModal: false,
			levelModal: false,
			tagModal: false,
			activationdate: '',
			createdate: '',
			creator: '',
			isDisabled: true,
			userNameDisabled: false,
			data: {},
			staffList: [],
			lineList: [],
			levelList: [],
			fixLevelList: [],
			newLevelData: [],
			delList: [],
			tagList: [],
			fixTagList: [],
			newTagData: [],
			delTagList: [],
			invitationcodeid: '',
			provinceListTotal: [],
			provinceList: [],
			provinceList2: [],
			cityList: [],
			cityList2: [],
			areaList: [],
			districtList: [],
			districtList2: [],
			AuthorityList: {
				'03_0001_0001_00': false,
				'03_0001_0002_00': false,
				'03_0001_0003_00': false,
				'03_0001_0004_00': false,
				'03_0001_0005_00': false,
				'03_0001_0006_00': false,
				'03_0001_0007_00': false,
				'03_0001_0008_00': false,
				'03_0001_0009_00': false,
				'03_0001_0010_00': false,
				'03_0001_0011_00': false,
				'03_0001_0015_00': false,
				'03_0001_0016_00': false,
				'03_0001_0017_00': false
			},
			ruleForm: {
				minBuyAmount: '',
				replaceMinAmountFlag: 0,
				minBuyMoney: '',
				replaceMinMoneyFlag: 0,
				maxBuyMoney: '',
				replaceMaxMoneyFlag: 0,
				customercategoryid: '',
				id: '',
				name: '',
				code: '',
				syscode: '',
				invitationcode: '',
				staffid: '',
				disabledflag: 0,
				invoiceFlag: 0,
				productQueryType: 0,
				orderChannelType: 0,
				activationflag: 0,
				username: '',
				password: '',
				lineid: '',
				linkman: '',
				linktel: '',
				customerlevelid: '',
				customertagid: '',
				area: '',
				province: '',
				city: '',
				district: '',
				email: '',
				memo: '',
				appendixOne: '',
				appendixTwo: '',
				editnameflag: 0,
				storePhotoUrl: '',
				businessLicenseUrl: ''
			},
			addrList: [],
			defaultPassword: '******',
			phoneReg: /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/,
			usernameReg: /^[0-9]{11}$/,
			passwordReg: /^(?=.*[a-zA-Z]+)(?=.*[0-9]+)([a-zA-Z0-9]){6,20}$/,
			isAdd: null,
			customercategoryList: [],
			syscodeId: '',
			addFlag: true,
			rules: {
				name: [
					{ required: true, message: '请输入客户名称', trigger: 'blur' }
				],
				syscode: [
					{ required: true, message: '请输入客户注册码', trigger: 'blur' }
				],
				invitationcode: [
					{ required: true, message: '请生成客户码', trigger: 'change' }
				],
				staffid: [
					{ required: true, message: '请选择业务员', trigger: 'change' }
				],
				username: [
					{ required: true,
						validator: (rule, value, callback) => {
							if (value === '') {
								callback(new Error('登录账号不能为空'))
							} else if (!this.usernameReg.test(value)) {
								callback(new Error('请输入11位数字！'))
							} else {
								callback()
							}
						},
						trigger: 'blur'
					}
				],
				password: [
					{ required: true,
						validator: (rule, value, callback) => {
							if (value === '') {
								callback(new Error('请输入6-20位字母和数字组合密码！'))
							}	else if (value === '******') {
								callback()
							} else if (!this.passwordReg.test(value)) {
								callback(new Error('请输入6-20位字母和数字组合密码！'))
							} else {
								callback()
							}
						},
						trigger: 'blur'
					},
					{ min: 6, max: 20, message: '请输入6-20位字母和数字组合密码！', trigger: 'blur' }
				]
			},
			shopattendway: true,
			shopText: '',
			chooseShop: [],
			shopDialog: false,
			fxDataVerification: this.$fxUtils.fxDataVerification(),
			shopList: [],
			addressTitle: '',
			addressDialogType: '',
			showAddressModal: false,
			locationLat: '',
			addressRuleForm: {
				name: '',
				tel: '',
				province: '',
				city: '',
				district: '',
				addr: {
					detail: '',
					local: ''
				},
				defaultflag: false
			},
			addressData: {},
			addressRules: {
				name: [
					{ required: true, validator: isNull, message: '请填写收货人姓名', trigger: 'blur' }
				],
				tel: [
					{ required: true,
						validator: (rule, value, callback) => {
							if (value === '') {
								callback(new Error('手机号码不能为空'))
							} else if (!this.phoneReg.test(value)) {
								callback(new Error('输入手机号不合法！'))
							} else {
								callback()
							}
						},
						trigger: 'blur'
					}
				],
				province: [
					{ required: true, message: '请选择省份', trigger: 'blur' }
				],
				city: [
					{ required: true, message: '请选择城市', trigger: 'blur' }
				],
				district: [
					{ required: true, message: '请选择地区', trigger: 'blur' }
				],
				addr: {
					// detail: [
					// 	{
					// 		required: true,
					// 		validator: (rule, value, callback) => {
					// 			callback()
					// 		},
					// 		trigger: 'change'
					// 	}
					// ],
					local: [
						{ required: true,
							validator: (rule, value, callback) => {
								var reg = /^[\s\S]*.*[^\s][\s\S]*$/
								if (!(reg.test(value))) {
									callback(new Error('请输入详细地址'))
								} else {
									callback()
								}
							},
							trigger: 'blur' }
					]
				}
			},
			oldLoggerRuleForm: {},
			newLoggerRuleForm: {},
			decimal: 0
		}
	},
	created () {
		this.provinceListTotal = provinceData.RECORDS
		this.provinceList = provinceData.RECORDS
		this.provinceList2 = provinceData.RECORDS
		this.areaList = geography
		this.ruleForm.id = window.sessionStorage.getItem('customerid')
		this.isAdd = window.sessionStorage.getItem('isCustomerAdd')
		this.getAuthority('03_0001_0000_00')
		this.getCustomercategory()
		this.getLevelList()
		this.getTagList()
		this.getLineList()
		this.getOrderSystemSetting()
		this.getStaffList().then(data => {
			if (this.ruleForm.id !== '') {
				this.addFlag = false
				// this.userNameDisabled = true
				this.ruleForm.password = this.defaultPassword
				this.getInfo()
			} else {
				this.addFlag = true
				this.ruleForm.customercategoryid = window.sessionStorage.getItem('customercategoryid')
				this.ruleForm.password = ''
				this.getAllFlag()
			}
		})
		this.getShop()
	},
	mounted () {
	},
	methods: {
		handleOtherInfoCollapse () {
			this.otherInfoCollapse = !this.otherInfoCollapse
		},
		maxBuyMoneyBlur () {
			if (this.ruleForm.maxBuyMoney === '') {
			} else {
				this.ruleForm.maxBuyMoney = this.$fxUtils.toFixedSHW(this.ruleForm.maxBuyMoney, 2)
				if (this.ruleForm.maxBuyMoney > 5000000) {
					this.ruleForm.maxBuyMoney = '5000000.00'
				}
				if (this.ruleForm.maxBuyMoney < 0) {
					this.ruleForm.maxBuyMoney = '0.00'
				}
			}
		},
		getOrderSystemSetting () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/getOrderSystemSetting`
			}).then(res => {
				if (res.result) {
					this.decimal = res.data.orderdecimalcount
				} else {
					this.$message.error(res.msg)
				}
			}).catch((res) => {
				this.$message.error(res.msg)
			})
		},
		minBuyAmountInput () {
			this.ruleForm.minBuyAmount = this.ruleForm.minBuyAmount.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.ruleForm.minBuyAmount = this.ruleForm.minBuyAmount.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.ruleForm.minBuyAmount = this.ruleForm.minBuyAmount.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.ruleForm.minBuyAmount = this.ruleForm.minBuyAmount.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			switch (this.decimal) {
			case 0:
				this.ruleForm.minBuyAmount = this.ruleForm.minBuyAmount.replace(/[^\d]/g, '')
				break
			case 1:
				this.ruleForm.minBuyAmount = this.ruleForm.minBuyAmount.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3')
				break
			case 2:
				this.ruleForm.minBuyAmount = this.ruleForm.minBuyAmount.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
				break
			case 3:
				this.ruleForm.minBuyAmount = this.ruleForm.minBuyAmount.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3')
				break
			case 4:
				this.ruleForm.minBuyAmount = this.ruleForm.minBuyAmount.replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3')
				break
			}
			if (this.ruleForm.minBuyAmount.indexOf('.') !== -1) {
				if (this.ruleForm.minBuyAmount.split('.')[0] === '') {
					this.ruleForm.minBuyAmount = ''
				}
			}
		},
		minBuyAmountBlur () {
			if (this.ruleForm.minBuyAmount === '') {
			} else {
				this.ruleForm.minBuyAmount = this.$fxUtils.toFixedSHW(this.ruleForm.minBuyAmount, 3)
				if (this.ruleForm.minBuyAmount > 1000000) {
					this.ruleForm.minBuyAmount = 999999
				}
				if (this.ruleForm.minBuyAmount < 0) {
					this.ruleForm.minBuyAmount = 0
				}
			}
		},
		minBuyMoneyBlur () {
			if (this.ruleForm.minBuyMoney === '') {
			} else {
				this.ruleForm.minBuyMoney = this.$fxUtils.toFixedSHW(this.ruleForm.minBuyMoney, 2)
				if (this.ruleForm.minBuyMoney > 5000000) {
					this.ruleForm.minBuyMoney = '5000000.00'
				}
				if (this.ruleForm.minBuyMoney < 0) {
					this.ruleForm.minBuyMoney = '0.00'
				}
			}
		},
		getShop () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/selectShopList`
			}).then(res => {
				this.shopList = res
			}).catch(() => {
			})
		},
		provinceChange () {
			this.cityList = []
			this.districtList = []
			this.ruleForm.city = ''
			this.ruleForm.district = ''
			let a = cityData.RECORDS
			for (let i = 0; i < a.length; i++) {
				if (this.ruleForm.province === a[i].pid) {
					this.cityList.push(a[i])
				}
			}
		},
		provinceChange2 (e) {
			this.districtList2 = []
			this.cityList2 = []
			this.addressRuleForm.district = ''
			this.addressRuleForm.city = ''
			let a = cityData.RECORDS
			if (this.addressDialogType === 'add') {
				for (let i = 0; i < a.length; i++) {
					if (JSON.parse(this.addressRuleForm.province).id === a[i].pid) {
						this.cityList2.push(a[i])
					}
				}
			} else {
				for (let i = 0; i < a.length; i++) {
					if (this.addressRuleForm.province === a[i].pid) {
						this.addressRuleForm.provincename = a[i].name
						this.cityList2.push(a[i])
					}
				}
			}
		},
		cityChange () {
			let province = this.ruleForm.province
			let city = this.ruleForm.city
			this.districtList = []
			this.ruleForm.district = ''
			for (let i = 0; i < areaData.length; i++) {
				if (province === areaData[i].code) {
					for (let j = 0; j < areaData[i].child.length; j++) {
						if (city === areaData[i].child[j].code) {
							this.districtList = areaData[i].child[j].child
						}
					}
				}
			}
		},
		cityChange2 (e) {
			let province = this.addressDialogType === 'add' ? JSON.parse(this.addressRuleForm.province).name : this.addressRuleForm.province
			let city = this.addressDialogType === 'add' ? JSON.parse(this.addressRuleForm.city).id : this.addressRuleForm.city
			// this.autoInput.setCity(city)
			this.districtList2 = []
			this.addressRuleForm.district = ''
			if (this.addressDialogType === 'add') {
				for (let i = 0; i < areaData.length; i++) {
					if (province === areaData[i].name) {
						for (let j = 0; j < areaData[i].child.length; j++) {
							if (city === areaData[i].child[j].code) {
								this.districtList2 = areaData[i].child[j].child
							}
						}
					}
				}
			} else {
				for (let i = 0; i < areaData.length; i++) {
					if (province === areaData[i].code) {
						for (let j = 0; j < areaData[i].child.length; j++) {
							if (city === areaData[i].child[j].code) {
								this.addressRuleForm.cityname = areaData[i].child[j].name
								this.districtList2 = areaData[i].child[j].child
							}
						}
					}
				}
			}
		},
		districtChange2 (e) {
			this.districtList2.forEach(item => {
				if (item.code === e) {
					this.addressRuleForm.districtname = item.name
				}
			})
		},
		areaChange (e) {
			this.ruleForm.city = ''
			this.ruleForm.province = ''
			this.ruleForm.district = ''
			this.provinceList = []
			this.cityList = []
			this.districtList = []
			let a = this.provinceListTotal
			if (e === '') {
				this.provinceList = a
			}
			for (let i = 0; i < a.length; i++) {
				if (a[i].areacode === e) {
					this.provinceList.push(a[i])
				}
			}
		},
		getAllFlag () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/findAppAll`
			}).then(res => {
				if (res.result) {
					this.ruleForm.disabledflag = res.data.defaultcustomerdisabledflag ? 0 : 1
				}
			})
		},
		// 客户等级
		levelOpen () {
			this.newLevelData = this.fixLevelList
			this.delList = []
		},
		addLevel () {
			this.levelModal = true
		},
		closeLevel () {
			this.levelModal = false
		},
		deleteNew (index) {
			let id = this.newLevelData[index].customerlevelid
			if (id !== '') {
				this.delList.push({ 'id': id })
			}
			this.newLevelData.splice(index, 1)
		},
		deleteOld (id, index) {
			this.levelList.splice(index, 1)
			this.delList.push(id)
		},
		saveLevel () {
			let addArr = []
			let oldArr = []
			this.newLevelData.forEach(item => {
				item.id = item.customerlevelid
				item.aliasName = item.customerlevelname
				if (item.id === '') {
					addArr.push(item)
				} else {
					oldArr.push(item)
				}
			})
			let params = {
				addCustomerLevelList: addArr,
				updateCustomerLevelList: oldArr,
				removeCustomerLevelList: this.delList
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/saveOrDelCustomerLevel`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.levelModal = false
					this.ruleForm.customerlevelid = ''
					this.getLevelList()
					this.delList = []
					this.$message.success('保存成功')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		// 新增
		addBarcode () {
			let numArr = this.newLevelData.map(item => {
				return item.level
			})
			let index = 1
			let flag = true
			if (numArr.length > 0) {
				for (let i = 1; i < (numArr.length + 2); i++) {
					let isHave = numArr.includes(i)
					if (flag && !isHave) {
						index = i
						flag = false
					}
				}
			}
			let add = { customerlevelname: '', level: index, levelName: 'vip' + index, customerlevelid: '' }
			this.newLevelData.push(add)
			this.newLevelData = this.newLevelData.sort(this.compare('level'))
		},
		compare (property) {
			return (a, b) => {
				var value1 = a[property]
				var value2 = b[property]
				return value1 - value2
			}
		},
		// 客户标签
		tagOpen () {
			this.tagList = this.fixTagList
			this.newTagData = []
			this.delTagList = []
		},
		addTag () {
			this.tagModal = true
		},
		closeTag () {
			this.tagModal = false
		},
		deleteTagNew (index) {
			this.newTagData.splice(index, 1)
		},
		deleteTagOld (id, index) {
			this.tagList.splice(index, 1)
			this.delTagList.push(id)
		},
		saveTag () {
			for (let i = 0; i < this.newTagData.length; i++) {
				if (!this.newTagData[i].customertagname) {
					this.$message.error('新增名称不能为空')
					return false
				}
			}
			let duplicateArr = (this.newTagData.concat(this.tagList)).map(e => {
				return e.customertagname
			})
			let nary = duplicateArr.sort()
			for (let i = 0; i < duplicateArr.length; i++) {
				if (nary[i] === nary[i + 1]) {
					this.$message.error('客户标签名称不能重复')
					return false
				}
			}
			let arr = this.newTagData.map(e => {
				return e.customertagname
			})
			let params = {
				customertagnames: arr,
				customertagids: this.delTagList
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/saveOrDelCustomerTag`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.tagModal = false
					this.ruleForm.customertagid = ''
					this.getTagList()
					this.delTagList = []
					this.$message.success('保存成功')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		// 新增
		addTagName () {
			let add = { customertagname: '' }
			this.newTagData.push(add)
		},
		linktelChange () {
			this.ruleForm.linktel = this.ruleForm.linktel.replace(/[^\d-]/g, '')
			if (this.ruleForm.linktel.lastIndexOf('-') > -1) {
				let numArr = this.ruleForm.linktel.split('')
				numArr.splice(this.ruleForm.linktel.lastIndexOf('-'), 1)
				this.ruleForm.linktel = numArr.join('')
			}
		},
		nameChange () {
			var reg = /[',\\]/g
			var res = this.ruleForm.name.replace(reg, '')
			this.ruleForm.name = res
		},
		nameChange2 () {
			var reg = /[',\\]/g
			var res = this.ruleForm.name.replace(reg, '')
			this.addressRuleForm.name = res
		},
		staffChange () {
			let list = this.staffList
			for (let i = 0; i < list.length; i++) {
				if (this.ruleForm.staffid === list[i].staffid) {
					this.ruleForm.invitationcode = list[i].invitationCode
					this.imgurl = list[i].imgUrl
					this.staffName = list[i].staffName
				}
			}
		},
		downLoadImg () {
			let data = this.imgurl
			const req = new XMLHttpRequest()
			let _this = this
			req.open('POST', `${this.$fxBaseApi.urlQNVShop}/customer/QRCode/download`, true)
			req.responseType = 'blob'
			req.setRequestHeader('Content-Type', 'application/json')
			req.setRequestHeader('pname', 'bc2ff5388144d30e137b28acafd39795')
			req.setRequestHeader('shiroSession', window.sessionStorage.getItem('shiroSession'))
			req.onload = function () {
				const data = req.response
				const blob = new Blob([data])
				const blobUrl = window.URL.createObjectURL(blob)
				_this.download(blobUrl)
			}
			req.send(data)
		},
		download (blobUrl) {
			const a = document.createElement('a')
			a.style.display = 'none'
			a.download = 'picture.jpg'
			a.href = blobUrl
			a.click()
		},
		closeModal () {
			this.showModal = false
		},
		showPic () {
			this.showModal = true
		},
		getStaffList () {
			return new Promise(resolve => {
				this.staffList = []
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlIV}/account/businessStaff/list`
				}).then(res => {
					if (res.result === true) {
						this.staffList = res.data
						resolve(res.data)
					} else {
						this.$message.error(res.msg)
					}
				})
			})
		},
		getInvitationcode () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/newInvitation`
			}).then(res => {
				if (res.result === true) {
					this.ruleForm.invitationcode = res.data.invitationcode
					this.invitationcodeid = res.data.id
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		getAuthority (pid) {
			let params = {
				pId: pid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
					let add = window.sessionStorage.getItem('isCustomerAdd')
					if (add === 'true') {
						if (this.AuthorityList['03_0001_0005_00']) {
							this.isDisabled = false
						} else {
							this.isDisabled = true
						}
					} else {
						if (this.AuthorityList['03_0001_0003_00']) {
							this.isDisabled = false
						} else {
							this.isDisabled = true
						}
					}
				}
			})
		},
		getLevelList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/getCustomerLevelList`
			}).then(res => {
				this.fixLevelList = res.data
				this.levelList = res.data
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		getTagList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/getCustomerTagList`
			}).then(res => {
				this.fixTagList = res.data
				this.tagList = res.data
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		getLineList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/line/listfilter`
			}).then(res => {
				this.lineList = res
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		getCustomercategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customerCategory/list`
			}).then(res => {
				if (res.result) {
					this.customercategoryList = res.data.childNode
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		getInfo () {
			let params = {
				id: this.ruleForm.id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/findCustomerDetailInfo`,
				data: params
			}).then(res => {
				if (res.result) {
					window.sessionStorage.setItem('customerName', res.data.name)
					this.data = res.data
					this.createdate = res.data.createdate
					this.activationdate = res.data.activationdate
					this.staffName = res.data.staffName
					// this.shopname = res.data.shopname
					this.users = res.data.users
					this.creator = res.data.creator
					this.imgurl = res.data.imgurl
					this.ruleForm.code = res.data.code
					this.invitationcodeid = res.data.invitationcodeid
					this.ruleForm.disabledflag = res.data.disabledflag
					this.ruleForm.invoiceFlag = res.data.invoiceFlag
					this.ruleForm.minBuyAmount = res.data.minBuyAmount
					this.ruleForm.replaceMinAmountFlag = res.data.replaceMinAmountFlag
					this.ruleForm.minBuyMoney = res.data.minBuyMoney
					this.ruleForm.replaceMinMoneyFlag = res.data.replaceMinMoneyFlag
					this.ruleForm.maxBuyMoney = res.data.maxBuyMoney === null ? '' : res.data.maxBuyMoney
					this.ruleForm.replaceMaxMoneyFlag = res.data.replaceMaxMoneyFlag
					this.ruleForm.editnameflag = res.data.editnameflag
					this.ruleForm.productQueryType = res.data.pmdata.productQueryType
					this.ruleForm.orderChannelType = res.data.pmdata.orderChannelType !== null && res.data.pmdata.orderChannelType !== undefined ? res.data.pmdata.orderChannelType : 0
					this.ruleForm.name = res.data.name
					this.ruleForm.customercategoryid = res.data.customercategoryid
					this.ruleForm.customercategoryname = res.data.customercategoryname
					this.ruleForm.lineid = res.data.lineid
					this.ruleForm.linkman = res.data.linkman
					this.ruleForm.linktel = res.data.linktel
					this.ruleForm.customerlevelid = res.data.customerlevelid
					this.ruleForm.customertagid = res.data.customertagid
					this.ruleForm.area = res.data.area
					this.ruleForm.province = res.data.province
					this.ruleForm.city = res.data.city
					this.ruleForm.district = res.data.district
					this.shopattendway = res.data.relallshopflag
					this.cityList = []
					this.districtList = []
					if (this.ruleForm.area !== null && this.ruleForm.area !== '') {
						this.provinceList = []
						let b = this.provinceListTotal
						for (let i = 0; i < b.length; i++) {
							if (b[i].areacode === this.ruleForm.area) {
								this.provinceList.push(b[i])
							}
						}
					}
					let a = cityData.RECORDS
					for (let i = 0; i < a.length; i++) {
						if (this.ruleForm.province === a[i].pid) {
							this.cityList.push(a[i])
						}
					}
					for (let i = 0; i < areaData.length; i++) {
						if (this.ruleForm.province === areaData[i].code) {
							for (let j = 0; j < areaData[i].child.length; j++) {
								if (this.ruleForm.city === areaData[i].child[j].code) {
									this.districtList = areaData[i].child[j].child
								}
							}
						}
					}
					this.ruleForm.positionName = this.getPositionName(this.ruleForm)
					this.ruleForm.email = res.data.email
					this.ruleForm.memo = res.data.memo
					this.ruleForm.appendixOne = res.data.appendixOne
					this.ruleForm.appendixTwo = res.data.appendixTwo
					this.ruleForm.storePhotoUrl = res.data.storePhotoUrl || ''
					this.ruleForm.businessLicenseUrl = res.data.businessLicenseUrl || ''
					this.showCustomerPhotos = this.hasCustomerPhotoUrl(res.data.businessLicenseUrl) && this.hasCustomerPhotoUrl(res.data.storePhotoUrl)
					res.data.addrList.forEach((e) => {
						if (e.addr.indexOf('{"detail"') !== -1) {
							e.addr = JSON.parse(e.addr.replace(/[\r\n\t]/g, '').replace(/(?<=([^{:,]))(")(?=([^}:,]))/g, '\\\"'))
							// e.addr = e.addr.detail + e.addr.local
						}
					})
					this.addrList = res.data.addrList
					this.ruleForm.syscode = res.data.syscode
					this.ruleForm.staffid = res.data.staffid
					this.ruleForm.invitationcode = res.data.invitationcode
					this.ruleForm.activationflag = res.data.activationflag
					this.ruleForm.username = res.data.tel
					this.syscodeId = res.data.syscodeId
					if (res.data.staffid !== '') {
						let flag = true
						this.staffList.forEach(e => {
							if (e.staffid === res.data.staffid) {
								flag = false
							}
						})
						if (flag) {
							let noHave = {
								imgUrl: res.data.imgurl,
								invid: res.data.invitationcodeid,
								invitationCode: res.data.invitationcode,
								staffName: res.data.staffName,
								staffNumber: res.data.staffNumber,
								staffType: res.data.staffType,
								staffid: res.data.staffid
							}
							this.staffList.push(noHave)
						}
					}
					this.initShopData(res.data.shops)
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		createLoggerParams () {
			const originData = this.fxDataVerification.getOriginData()
			originData.areaName = this.getAreaName(originData.area)
			originData.customerlevelname = this.getLevelName(originData.customerlevelid)
			originData.customertagname = this.getTagName(originData.customertagid)
			originData.linename = this.getLineName(originData.lineid)
			const ruleForm = this.$fxUtils.deepClone(this.ruleForm)
			ruleForm.areaName = this.getAreaName(ruleForm.area)
			ruleForm.positionName = this.getPositionName(ruleForm)
			ruleForm.customercategoryname = this.getCategoryName(ruleForm.customercategoryid)
			ruleForm.customerlevelname = this.getLevelName(ruleForm.customerlevelid)
			ruleForm.customertagname = this.getTagName(ruleForm.customertagid)
			ruleForm.linename = this.getLineName(ruleForm.lineid)
			ruleForm.shopMsg = this.shopattendway ? '全部门店' : this.shopText
			return {
				pre: originData,
				cur: ruleForm,
				name: ruleForm.name
			}
		},
		getAreaName (code) {
			if (!code) {
				return ''
			}
			return (this.areaList.find(item => {
				return item.code === code
			}) || {}).name
		},
		getPositionName ({ province, city, district }) {
			if (!province || !city || !district) {
				return ''
			}
			const _province = (this.provinceList.find(item => {
				return item.id === province
			}) || {}).name
			const _city = (this.cityList.find(item => {
				return item.id === city
			}) || {}).name
			const _district = (this.districtList.find(item => {
				return item.code === district
			}) || {}).name
			return `${_province}-${_city}-${_district}`
		},
		getCategoryName (code) {
			if (!code) {
				return ''
			}
			return (this.customercategoryList.find(item => {
				return item.ccid === code
			}) || {}).ccname
		},
		getLevelName (code) {
			if (!code) {
				return ''
			}
			return (this.fixLevelList.find(item => {
				return item.customerlevelid === code
			}) || {}).customerlevelname
		},
		getTagName (code) {
			if (!code) {
				return ''
			}
			return (this.fixTagList.find(item => {
				return item.customertagid === code
			}) || {}).customertagname
		},
		getLineName (code) {
			if (!code) {
				return ''
			}
			return (this.lineList.find(item => {
				return item.lineid === code
			}) || {}).codeandname
		},
		codeBlur () {
			if (this.ruleForm.code === '' || this.ruleForm.code === null) {
				this.ruleForm.code = null
			}
			if (this.ruleForm.code !== null) {
				this.ruleForm.code = +this.ruleForm.code
				if (this.ruleForm.code > 99999) {
					this.ruleForm.code = 99999
				}
				if (this.ruleForm.code < 0) {
					this.ruleForm.code = 0
				}
				this.ruleForm.code = parseInt(this.ruleForm.code)
			}
		},
		codeChange () {
			this.ruleForm.code = this.ruleForm.code.trim()
			this.ruleForm.code = this.ruleForm.code.replace(/[',\\]/g, '')
		},
		linkmanChange () {
			this.ruleForm.linkman = this.ruleForm.linkman.trim()
			this.ruleForm.linkman = this.ruleForm.linkman.replace(/[',\\]/g, '')
		},
		levelChange (index) {
			this.newLevelData[index].customerlevelname = this.newLevelData[index].customerlevelname.trim()
			this.newLevelData[index].customerlevelname = this.newLevelData[index].customerlevelname.replace(/[',\\]/g, '')
		},
		tagChange (index) {
			this.newTagData[index].customerlevelname = this.newTagData[index].customerlevelname.trim()
			this.newTagData[index].customerlevelname = this.newTagData[index].customerlevelname.replace(/[',\\]/g, '')
		},
		checkCode () {
			let params = {
				syscode: this.ruleForm.syscode,
				id: this.ruleForm.id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/checkBuyerSyscode`,
				data: params
			}).then(res => {
				if (res.result) {
					const h = this.$createElement
					this.$msgbox({
						title: '提示',
						message: h('div', null, [
							h('div', { style: 'padding-left:20px' }, '客户集团名称:' + res.data.entName),
							h('div', { style: 'padding-left:20px' }, '客户手机号:' + res.data.tel),
							h('div', { style: 'padding-left:20px' }, '注册号:' + res.data.syscode),
							h('div', { style: 'padding-left:20px' }, '请确认是否保存？')
						]),
						showCancelButton: true,
						closeOnClickModal: false,
						confirmButtonText: '确定',
						cancelButtonText: '取消'
					}).then(action => {
						this.save()
					})
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		submitForm (formName) {
			if (this.ruleForm.staffid !== '' && this.ruleForm.invitationcode === '') {
				this.$message.error('请生成客户码')
			} else if (this.ruleForm.staffid === '' && this.ruleForm.invitationcode !== '') {
				this.$message.error('请选择业务员')
			} else if (this.shopattendway === false && this.chooseShop.length === 0) {
				this.$message.error('请选择适用门店')
			} else if ((this.ruleForm.maxBuyMoney !== '' && this.ruleForm.minBuyMoney !== '') && (+this.ruleForm.maxBuyMoney < +this.ruleForm.minBuyMoney)) {
				this.$message.error('您输入的最大订货金额小于当前设置的最小订货量金额，请您重新输入')
			} else if (this.showCustomerPhotos && !this.hasCustomerPhotoUrl(this.ruleForm.businessLicenseUrl)) {
				this.$message.error('请上传营业执照')
			} else if (this.showCustomerPhotos && !this.hasCustomerPhotoUrl(this.ruleForm.storePhotoUrl)) {
				this.$message.error('请上传门店照')
			} else {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.save()
					}
				})
			}
		},
		hasCustomerPhotoUrl (url) {
			return !!(url && String(url).trim())
		},
		save () {
			let password = ''
			if (this.ruleForm.password === this.defaultPassword) {
				password = ''
			} else {
				password = this.ruleForm.password
			}
			const params = {}
			params.name = this.ruleForm.name
			params.syscode = this.ruleForm.syscode
			params.code = this.ruleForm.code
			params.disabledflag = this.ruleForm.disabledflag
			params.invoiceFlag = this.ruleForm.invoiceFlag
			params.customercategoryid = this.ruleForm.customercategoryid
			params.id = this.ruleForm.id
			params.lineid = this.ruleForm.lineid
			params.linkman = this.ruleForm.linkman
			params.linktel = this.ruleForm.linktel
			params.customerlevelid = this.ruleForm.customerlevelid
			params.customertagid = this.ruleForm.customertagid
			params.area = this.ruleForm.area
			params.province = this.ruleForm.province
			params.city = this.ruleForm.city
			params.district = this.ruleForm.district
			params.email = this.ruleForm.email
			params.memo = this.ruleForm.memo
			params.appendixOne = this.ruleForm.appendixOne
			params.appendixTwo = this.ruleForm.appendixTwo
			params.storePhotoUrl = this.ruleForm.storePhotoUrl
			params.businessLicenseUrl = this.ruleForm.businessLicenseUrl
			params.staffid = this.ruleForm.staffid
			params.password = password
			params.tel = this.ruleForm.username
			params.minBuyAmount = this.ruleForm.minBuyAmount
			params.replaceMinAmountFlag = this.ruleForm.replaceMinAmountFlag
			params.minBuyMoney = this.ruleForm.minBuyMoney
			params.replaceMinMoneyFlag = this.ruleForm.replaceMinMoneyFlag
			params.maxBuyMoney = this.ruleForm.maxBuyMoney
			params.replaceMaxMoneyFlag = this.ruleForm.replaceMaxMoneyFlag
			params.editnameflag = this.ruleForm.editnameflag
			params.productQueryType = this.ruleForm.productQueryType
			params.orderChannelType = this.ruleForm.orderChannelType
			params.relAllsShopFlag = this.shopattendway
			params.relShopIdList = this.chooseShop
			let logger
			if (!this.addFlag) {
				params.syscodeid = this.syscodeId
				logger = this.$fxLogger.createInfo('custom.custom-info.update', this.createLoggerParams())
			} else {
				logger = this.$fxLogger.createInfo('custom.custom-info.add', { name: params.name })
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/saveOrUpdateCustomer`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功')
					this.ruleForm.id = res.data.id
					this.ruleForm.password = this.defaultPassword
					this.addFlag = false
					// this.userNameDisabled = true
					window.sessionStorage.setItem('customerid', res.data.id)
					window.sessionStorage.setItem('syscodeid', res.data.syscodeid)
					this.getInfo()
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		resetForm (formName) {
			this.$refs[formName].resetFields()
			if (this.ruleForm.id === '') {
				this.ruleForm.code = ''
				this.ruleForm.disabledflag = 0
				this.ruleForm.invoiceFlag = 0
				this.ruleForm.editnameflag = 0
				this.ruleForm.productQueryType = 0
				this.ruleForm.orderChannelType = 0
				this.ruleForm.replaceMinAmountFlag = 0
				this.ruleForm.replaceMinMoneyFlag = 0
				this.ruleForm.replaceMaxMoneyFlag = 0
			} else {
				this.getInfo()
			}
		},
		checkPhone () {
			if (this.ruleForm.username) {
				if (this.phoneReg.test(this.ruleForm.username)) {
					this.verifyTel()
				}
			}
		},
		verifyTel () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIVA}/verifytelfree/quickorder/${this.ruleForm.username}`
			}).then(res => {
				if (res.result) {
					return false
				} else {
					this.tipsHandle(`手机号码${this.ruleForm.username}已经注册`, 'error')
					this.ruleForm.username = ''
				}
			}).catch((res) => {
				this.$message.error(res.msg)
				this.ruleForm.username = ''
			})
		},
		tipsHandle (content, type, duration) {
			this.$message({
				message: content,
				type: type
			})
		},
		bindShopClick () {
			this.shopDialog = true
		},
		initShopData (data) {
			let textArr = []
			let ids = []
			data.forEach(item => {
				ids.push(item.id)
				textArr.push(item.name)
			})
			this.shopText = textArr.join('，')
			this.chooseShop = ids
			this.ruleForm.shopMsg = this.shopattendway ? '全部门店' : this.shopText
			this.fxDataVerification.resetData(this.ruleForm)
			this.shopname = this.shopattendway ? '全部门店' : this.shopText
		},
		reloadShop (data) {
			this.chooseShop = data.chooseData
			this.shopText = data.shopText
			this.shopDialog = false
		},
		load () {
			return new Promise((resolve, reject) => {
				var url = 'https://webapi.amap.com/maps?v=1.4.14&key=4840e0d822c880f0d785c9a2fa5b9d57'
				var script = document.createElement('script')
				script.charset = 'utf-8'
				script.src = url
				script.async = true
				script.defer = true
				script.type = 'text/javascript'
				document.head.appendChild(script)
				script.onload = () => {
					setTimeout(() => {
						_AMap = window.AMap
						_AMap.plugin(['AMap.Autocomplete'], (res) => {
							this.initSearchInput()
						})
						resolve('suc')
					}, 0)
				}
			})
		},
		initSearchInput () {
			// let city = this.addressRuleForm.cityname
			this.autoInput = new _AMap.Autocomplete({
				input: 'searchInput',
				city: '全国',
				citylimit: true,
				datatype: 'poi'
			})
			this.autoInput.on('select', (ev) => {
				this.addressRuleForm.addr.detail = ev.poi.name
				this.locationLng = ev.poi.location.lng
				this.locationLat = ev.poi.location.lat
				this.$refs['addressRuleForm'].validateField('addr.detail', (error) => {
					if (!error) {
						return true
					} else {
						return false
					}
				})
			})
		},
		addressInput (value) {
			this.locationLat = ''
		},
		addAddress (val, item) {
			this.addressDialogType = val
			this.addressTitle = val === 'add' ? '新增收货地址' : '编辑收货地址'
			if (val === 'add') {
				this.newLoggerRuleForm = {}
				this.oldLoggerRuleForm = {}
			} else {
				this.newLoggerRuleForm = {}
				this.oldLoggerRuleForm.name = item.name
				this.oldLoggerRuleForm.tel = item.tel
				this.oldLoggerRuleForm.provincename = item.provincename
				this.oldLoggerRuleForm.cityname = item.cityname
				this.oldLoggerRuleForm.districtname = item.districtname
				this.oldLoggerRuleForm.detail = item.addr.detail
				this.oldLoggerRuleForm.local = item.addr.local
				this.oldLoggerRuleForm.defaultflag = item.defaultflag
			}
			this.cityList2 = []
			this.districtList2 = []
			if (val === 'edit') {
				this.locationLat = undefined
				this.addressRuleForm = JSON.parse(JSON.stringify(item))
				let a = cityData.RECORDS
				for (let i = 0; i < a.length; i++) {
					if (this.addressRuleForm.province === a[i].pid) {
						this.cityList2.push(a[i])
					}
				}
				for (let i = 0; i < areaData.length; i++) {
					if (this.addressRuleForm.province === areaData[i].code) {
						for (let j = 0; j < areaData[i].child.length; j++) {
							if (this.addressRuleForm.city === areaData[i].child[j].code) {
								this.districtList2 = areaData[i].child[j].child
							}
						}
					}
				}
			} else {
				this.addressRuleForm = {
					name: '',
					tel: '',
					province: '',
					city: '',
					district: '',
					addr: {
						detail: '',
						local: ''
					},
					defaultflag: false
				}
			}
			// this.load()
			this.showAddressModal = true
		},
		closeAddressModal (formName) {
			this.$refs['addressRuleForm'].resetFields()
			this.addressRuleForm = {
				name: '',
				tel: '',
				province: '',
				city: '',
				district: '',
				addr: {
					detail: '',
					local: ''
				}
			}
			this.showAddressModal = false
		},
		deleteAddress (item) {
			// console.log(item)
			let logger = this.$fxLogger.createInfo('custom.custom-info.deleteAddress', { name: this.ruleForm.name, item })
			this.$confirm('确定删除该收货地址？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/customer/addr/del/${item.id}`,
					logger
				}).then(res => {
					if (res.result) {
						this.$message.success('删除成功')
						this.getInfo()
					} else {
						this.$message.error(res.msg)
					}
				}).catch(err => {
					this.$message.error(err.msg)
				})
			}).catch(() => {})
		},
		submitAddressForm (formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					let params = {}
					// console.log(this.addressRuleForm)
					if (this.addressRuleForm.addr.detail.indexOf('"') !== -1 || this.addressRuleForm.addr.local.indexOf('"') !== -1) {
						this.$message.error('地址请勿输入双引号')
						return
					}
					let addrData = JSON.stringify({
						detail: this.addressRuleForm.addr.detail.replace(/[\r\n\t]/g, ''),
						local: this.addressRuleForm.addr.local.replace(/[\r\n\t]/g, '')
					})
					let province = JSON.parse(this.addressRuleForm.province)
					let city = JSON.parse(this.addressRuleForm.city)
					let district = JSON.parse(this.addressRuleForm.district)
					let logger
					this.newLoggerRuleForm.name = this.addressRuleForm.name
					this.newLoggerRuleForm.tel = this.addressRuleForm.tel
					this.newLoggerRuleForm.provincename = this.addressDialogType === 'add' ? province.name : this.addressRuleForm.provincename
					this.newLoggerRuleForm.cityname = this.addressDialogType === 'add' ? city.name : this.addressRuleForm.cityname
					this.newLoggerRuleForm.districtname = this.addressDialogType === 'add' ? district.name : this.addressRuleForm.districtname
					this.newLoggerRuleForm.detail = this.addressRuleForm.addr.detail
					this.newLoggerRuleForm.local = this.addressRuleForm.addr.local
					this.newLoggerRuleForm.defaultflag = this.addressRuleForm.defaultflag
					let addChangeData = {
						pre: { addAddressRuleForm: this.oldLoggerRuleForm },
						cur: { addAddressRuleForm: this.newLoggerRuleForm },
						name: this.ruleForm.name
					}
					let editChangeData = {
						pre: { editeAddressRuleForm: this.oldLoggerRuleForm },
						cur: { editeAddressRuleForm: this.newLoggerRuleForm },
						name: this.ruleForm.name
					}
					if (this.addressDialogType === 'add') {
						params = {
							addr: addrData,
							area: province.areacode,
							areaname: null,
							city: city.id,
							cityname: city.name,
							coordinate: province.lng + ',' + province.lat,
							country: '',
							countryname: null,
							defaultflag: this.addressRuleForm.defaultflag,
							district: district.code,
							districtname: district.name,
							id: '',
							name: this.addressRuleForm.name,
							province: province.id,
							provincename: province.name,
							shopname: '',
							tel: this.addressRuleForm.tel,
							type: 1,
							wayname: '',
							customerId: window.sessionStorage.getItem('customerid')
						}
					} else {
						this.addressRuleForm.customerId = window.sessionStorage.getItem('customerid')
						this.addressRuleForm.addr = addrData
						params = this.addressRuleForm
					}
					logger = this.$fxLogger.createInfo(`custom.custom-info.${this.addressDialogType === 'add' ? 'addAddress' : 'update'}`, this.addressDialogType === 'add' ? addChangeData : editChangeData)
					this.$store.dispatch('requestPost', {
						url: `${this.$fxBaseApi.urlQIVShop}/customer/addr/addupdatebyjsd`,
						data: params,
						logger
					}).then(res => {
						if (res.result) {
							this.$message.success('保存成功')
							this.showAddressModal = false
							this.getInfo()
						} else {
							this.$message.error(res.msg)
						}
					}).catch(err => {
						this.$message.error(err.msg)
					})
				} else {
					return false
				}
			})
		}
	}
}
</script>
<style lang="stylus" scoped>
.business{
    width :100%;
    max-width: 100%;
    min-height :0;
	flex:1;
    display: flex;
	flex-direction: column;
	box-sizing: border-box;
	overflow: hidden;
	.inputPsd{
		-webkit-text-security:disc;
	}
    .business-body{
        flex: 1;
        min-height: 0;
        overflow-x: auto;
        overflow-y: auto;
        padding-left :20px;
        padding-right: 10px;
		display: flex;
		align-items: flex-start;
		min-width: 0;
		box-sizing: border-box;
		justify-content: space-between
		.business-main {
			flex: 0 0 auto;
			width: 920px;
			min-width: 920px;
			max-width: 920px;
			overflow: visible;
		}
		.business-top-row {
			display: flex;
			align-items: flex-start;
			justify-content: flex-start;
			flex-wrap: nowrap;
			margin-bottom: 10px;
			width: 100%;
			box-sizing: border-box;
		}
		.business-basic-fields {
			flex: 0 0 auto;
			width: auto;
		}
		.business-picture-area {
			display: flex;
			flex-direction: row;
			flex-wrap: nowrap;
			align-items: flex-start;
			flex: 0 0 532px;
			width: 532px;
			min-width: 532px;
			margin-left: 24px;
			overflow: visible;
			/deep/ .customer-photo-upload {
				flex: 0 0 260px !important;
				width: 260px !important;
				min-width: 260px !important;
				max-width: 260px !important;
			}
			/deep/ .customer-photo-upload + .customer-photo-upload {
				margin-left: 12px;
			}
		}
		.business-right {
			flex: 0 0 280px;
			width: 280px;
			min-width: 280px;
			text-align: left;
			padding-left: 20px;
			box-sizing: border-box;
			background: #fff;
			position: relative;
			.right-address{
				p {
					font-size: 15px;
					margin: 10px 0;
					font-weight: bold
				}
				i {
					cursor: pointer;
					font-size: 22px;
					color: var(--fx-primary-color);
					margin-left: 30px;
				}
				.address-item {
					line-height: 25px;
					white-space: nowrap;
					&>span {
						display: inline-block;
						width: 85px;
						font-size: 14px;
						text-align: right;
						margin-right: 10px;
					}
				}
			}
		}
        .box{
            width: 100%;
            .input-box{
                width :250px;
            }
            .radio-row-horizontal {
                display: flex !important;
                align-items: center;
                >>> .el-form-item__label {
                    float: none;
                    display: inline-flex;
                    align-items: center;
                    justify-content: flex-end;
                    height: auto;
                    line-height: 28px;
                    padding: 0 12px 0 0;
                }
                >>> .el-form-item__content {
                    margin-left: 0 !important;
                    flex: 1;
                    line-height: 28px;
                    display: flex;
                    align-items: center;
                }
                >>> .el-radio-group {
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    line-height: 28px;
                }
                >>> .el-radio {
                    margin-right: 20px;
                    white-space: nowrap;
                    line-height: 28px;
                    height: 28px;
                    display: inline-flex;
                    align-items: center;
                }
            }
            .el-form-item >>> .el-form-item__content{
                text-align :left
                }
        }
    }
    .business-foot{
        flex-shrink: 0;
        position: relative;
		bottom :5px;
        height :40px;
        padding-left 20px;
        margin-top :10px;
        width :100%;
        box-sizing: border-box;
        text-align :left;
    }
	.dialog-title{
		text-align :left
		.address {
			/deep/.el-form-item {
				margin-bottom: 20px;
				.el-form-item__content {
					display: flex;
					margin-left: 0 !important;
				}
			}
		}
	}
	.bar-wrap {
		max-height: 300px;
		overflow-y: auto;
		.bar-box {
			display: flex;
			align-items: center;
			padding-right: 20px;
			line-height: 20px;
			margin-bottom: 15px;
			.bar-content {
				flex: 1;
				display:flex
				padding: 0 20px
			}
			.bar-delete {
				margin-left: auto;
				flex-shrink: 0;
				text-decoration: underline;
				color: var(--fx-primary-color);
				cursor: pointer;
				font-size: 13px
			}
		}
	}
}
</style>
<style lang="stylus">
.business{
	.add-icon {
		color: var(--fx-primary-color);
		margin-left: 5px;
		font-size: 18px;
		cursor: pointer
	}
	.dialog-title1{
		text-align :left
		.el-dialog__body {
			padding-top: 0
		}
		.valet-foot {
			text-align: center;
			margin-top: 20px
		}
	}
}
.amap-sug-result {
	z-index: 9999
}
</style>
